import React, { useEffect, useState } from 'react'
import { WardnameHeaderDDL } from '../../../Components/CommonDDL/WardnameHeaderDDL'
import { FinancialYearHeaderDDL } from '../../../Components/CommonDDL/FinancialYearHeaderDDL'
import { MonthHeaderDDL } from '../../../Components/CommonDDL/MonthHeaderDDL'

export default function CommonDashboardWardNameDDL(props) {
    const { flag, HYear, YLable, HMonth, MLable, WLable, HWard, setWardValue, setWardLabel, HideYearMonthDDL,
        // FinancialYear, setFinancialYear,         Month, setMonth 
    } = props
    // console.log(FinancialYear)
    const [WardName, setWardName] = useState({
        DDL: [],
        // ID: 1,
        // Label: "Select Ward",
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    useEffect(() => {
        // console.log(WardName)
        if (setWardValue !== undefined) {
            setWardValue(WardName.ID)
        }
        if (setWardLabel !== undefined) {
            setWardLabel(WardName.Label)
        }
    }, [WardName.ID])

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Month, setMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    return (
        <>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <div className="page-header-title d-flex justify-content-between align-items-center">
                                <h5 className=" col-6 col-lg-2 ps-2 mt-2 ms-1 " style={{fontSize:"20px "}}>Dashboard</h5>

                                {/* {
                                        HideYearMonthDDL == 'Dashboard' && */}
                                {/* <div className="d-flex col-md-6  align-items-center justify-content-end">

                                    <FinancialYearHeaderDDL
                                        FinancialYear={FinancialYear}
                                        setFinancialYear={setFinancialYear}
                                        YLable={YLable}
                                        HYear={HYear}
                                        flag={flag}
                                    />
                                    <MonthHeaderDDL
                                        Month={Month}
                                        setMonth={setMonth}
                                        MLable={MLable}
                                        HMonth={HMonth}
                                        flag={flag}
                                    />

                                </div> */}
                                {/* } */}

                                {/* <p className=" col-6 col-lg-2 ps-2 fw-bold">Total Count : 00</p> */}
                                {/* <div className="col-md-6 col-lg-2 col-6 mr-3">
                                    <WardnameHeaderDDL
                                        WardName={WardName}
                                        setWardName={setWardName}
                                        WLable={WLable}
                                        HWard={HWard}
                                        flag={flag}
                                    />
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
